var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticStyle:{"color":"rgba(0, 0, 0, 0.54)","font-size":"10px","display":"block"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('span',{staticStyle:{"border-bottom":"1px solid rgba(0, 0, 0, 0.12)","display":"block"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }